import styled from 'styled-components'

export const Center = styled.div`
  width: 1200px;
  margin: 0 auto;

  @media(max-width: 900px) {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
`

export const Cards = styled.div`
  display: flex;
  color: #FFF;

  @media(max-width: 900px) {
    display: block;
  }  
`

export const Card = styled.div`
  background: #FFF;
  flex: 1;
  position: relative;
  border-radius: 10px;
  color: #000;
  padding: 20px;

  @media(max-width: 900px) {
    margin-bottom: 20px;
  }  

  + div {
    margin-left: 20px;

    @media(max-width: 900px) {
      margin-left: 0;
    }  
  }

  ul {
    list-style: none;
    list-style-position: inside;
    padding: 10px;
    padding-left: 34px;
    padding-bottom: 0;

    li {
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 10px;
    }
  }

  ul li::before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 10px;
    background: #f78734;
    margin-left: -24px;
  }

  h3 {
    color: #f78734;
    text-align: center;
    font-weight: 500;

    @media(max-width: 900px) {
      padding-top: 20px;
    }
  }

  .bottom-box {
    position: absolute;
    bottom: 0;
    width: 100%;

    @media(max-width: 900px) {
      position: relative;
    }  
  }
`

export const ButtonBox = styled.div`
  text-align: center;
  padding: 20px 0;
`

export const BtnAnchor = styled.a`
  border: none;
  border-radius: 0;
  background-clip: padding-box;
  background: #F78735;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  text-decoration: none;
  -webkit-transition: all 0.30s ease-in-out;
  -moz-transition: all 0.30s ease-in-out;
  -ms-transition: all 0.30s ease-in-out;
  -o-transition: all 0.30s ease-in-out;
  outline: none;
  padding: ${props => props.small ? '5px 16px' : '20px 40px 17px'};
  text-transform: uppercase;
  display: inline-block;

  &:hover {
    background: #000;
    cursor: pointer;
    text-decoration: none !important;
  }
`;
